export const PAGINATION_PER_PAGE = 10;
export const PIE_CHART_PER_PAGE = 4;
export const COMPARED_OPTIONS = [
    {
        id: 0,
        name: 'No fill',
    },
    {
        id: 1,
        name: 'More Than',
    },
    {
        id: 2,
        name: 'Less Than',
    },
    {
        id: 3,
        name: 'Equal',
    },
];
export const GIVEN_TYPE_OPTIONS = [
    {
        id: 0,
        name: 'No fill',
    },
    {
        id: 1,
        name: 'Point',
    },
    {
        id: 2,
        name: 'Hp',
    },
];
export const REVEALED_PHASE_OPTIONS = [
    {
        id: 0,
        name: 'No fill',
    },
    {
        id: 1,
        name: 'Stand by',
    },
    {
        id: 2,
        name: 'Main phase',
    },
    {
        id: 3,
        name: 'Scout',
    },
    {
        id: 4,
        name: 'Parley',
    },
    {
        id: 5,
        name: 'Pre duel',
    },
    {
        id: 6,
        name: 'Post duel',
    },
    {
        id: 7,
        name: 'End phase',
    },
];

export const PROMPT_OPTIONS = [
    {
        id: 0,
        name: 'No fill',
    },
    {
        id: 1,
        name: 'Both Players Prompt',
    },
    {
        id: 2,
        name: 'User Revealer Prompt',
    },
    {
        id: 3,
        name: 'Opponent Player Prompt',
    },
    {
        id: 4,
        name: 'User Winner Prompt',
    },
    {
        id: 5,
        name: 'Before Effect Prompt ',
    },
];

export const AWS_S3_DOMAIN = "https://halfwish.s3.ap-southeast-1.amazonaws.com";
export const PLACEHOLDER_IMAGE = AWS_S3_DOMAIN + '/img/missing-icon.png';
export const PLACEHOLDER_ICON = AWS_S3_DOMAIN + '/img/placeholder-icon.png';
export const IMAGE_NOT_AVAILABLE = AWS_S3_DOMAIN + '/img/missing-icon.png';
export const MAX_FILE_SIZE_ALLOWED = 1024 * 1024 * parseInt(process.env.MAX_FILE_SIZE_ALLOWED_IN_MB);
export const CARD_NAME_REGEX = /[^\w'.()-]+/;
export const IMAGE_WITH_IN_PIXEL = 750;
export const IMAGE_HEIGHT_IN_PIXEL = 1050;
export const IMG_WIDTH = '17.3rem'; //500x700
export const IMG_HEIGHT = '24.2rem'; //500x700
export const CROP_WIDTH = 11 + 'rem'; //175x175
export const CROP_HEIGHT = 11 + 'rem';
export const MAX_DESCRIPTION = 255;
export const UNAUTHORIZED = 'UNAUTHORIZED.';
export const INTERNAL_SERVER_ERROR = 'Internal Server Error.';
export const UNKNOWN_ERROR = 'Unknown Error.';
export const GUTTER_SIZE = 5;
export const COLUMN_WIDTH = 555;
export const ROW_HEIGHT = 300;
export const ACCEPTED_MIME_TYPES = process.env.ACCEPTED_MIME_TYPES.split(',');

export const FAMILIAR_TYPES = [
    {
        "id": "conqueror",
        "name": "Conqueror"
    },
    {
        "id": "protector",
        "name": "Protector"
    },
    {
        "id": "predator",
        "name": "Predator"
    },
    {
        "id": "vigilant",
        "name": "Vigilant"
    }];


export const EQUIPMENT_RARITY = [
    {
        "id": "signature",
        "name": "Signature"
    },
    {
        "id": "rare",
        "name": "Rare"
    },
    {
        "id": "epic",
        "name": "Epic"
    },
    {
        "id": "geagax",
        "name": "Geagax"
    }
];
export const ITEMS = [
    {
        "id": "hero",
        "name": "Hero"
    },
    {
        "id": "familiar",
        "name": "Familiar"
    },
    {
        "id": "hero_skin",
        "name": "Hero Skin"
    },
    {
        "id": "dice_skin",
        "name": "Dice Skin"
    },
    {
        "id": "card_skin",
        "name": "Card Skin"
    },
    {
        "id": "gear",
        "name": "Gear"
    },
    {
        "id": "artifact",
        "name": "Artifact"
    },
    {
        "id": "emote",
        "name": "Emote"
    },
    {
        "id": "player_icon",
        "name": "Player Icon"
    },
    {
        "id": "consumable",
        "name": "Consumable"
    },
    {
        "id": "item",
        "name": "Item"
    },
    {
        "id": "loot_box",
        "name": "Loot Box"
    }
    
];

export const REWARDS = [
    {
        "id": "REW001",
        "name": "Reward 1"
    },
    {
        "id": "REW002",
        "name": "Reward 2"
    },
];

export const DURABILITIES = [
    {
        "id": "1",
        "name": "Factory Made"
    },
    {
        "id": "2",
        "name": "Guild Standard"
    },
    {
        "id": "3",
        "name": "Mastercrafted"
    },
];

export const RARITY = [
    {
        "id": "SSR",
        "name": "SSR"
    },
    {
        "id": "SR",
        "name": "SR"
    },
];

export const EMOTE_RARITY = [
    {
        "id": "rare",
        "name": "Rare"
    },
    {
        "id": "epic",
        "name": "Epic"
    },
    {
        "id": "legendary",
        "name": "Legendary"
    },
];


export const PLAYER_ICON_RARITY = [
    {
        "id": "rare",
        "name": "Rare"
    },
    {
        "id": "epic",
        "name": "Epic"
    },
    {
        "id": "legendary",
        "name": "Legendary"
    },
];

export const ORIGIN = [
    {
        "id": "Terra",
        "name": "Terra"
    },
    {
        "id": "Chimera",
        "name": "Chimera"
    },
    {
        "id": "Bethas",
        "name": "Bethas"
    },
    {
        "id": "Jiushido",
        "name": "Jiushido"
    },
    {
        "id": "Nauca",
        "name": "Nauca"
    },
    {
        "id": "Avasa",
        "name": "Avasa"
    },
    {
        "id": "Geagax",
        "name": "Geagax"
    },
    {
        "id": "Valran",
        "name": "Valran"
    },
    {
        "id": "Vizan",
        "name": "Vizan"
    },
    {
        "id": "Outskirts",
        "name": "Outskirts"
    },
];

export const HERO_SKIN_RARITY = [
    {
        "id": "rare",
        "name": "Rare"
    },
    {
        "id": "epic",
        "name": "Epic"
    },
    {
        "id": "exotic",
        "name": "Exotic"
    },
];

export const DICE_SKIN_RARITY = [
    {
        "id": "rare",
        "name": "Rare"
    },
    {
        "id": "epic",
        "name": "Epic"
    },
    {
        "id": "legendary",
        "name": "Legendary"
    },
];

export const CARD_SKIN_RARITY = [
    {
        "id": "rare",
        "name": "Rare"
    },
    {
        "id": "epic",
        "name": "Epic"
    },
    {
        "id": "exotic",
        "name": "Exotic"
    },
];

export const EXCLUSIVE_OFFER_TYPE = [
    {
        "id": "rare_hero_offer",
        "name": "Rare Hero Offer"
    },
    {
        "id": "normal_hero_offer",
        "name": "Normal Hero Offer"
    },
    {
        "id": "gear_and_artifact_offer",
        "name": "Gear and Artifact Offer"
    },
    {
        "id": "consumable_offer",
        "name": "Consumable Offer"
    }
];

export const SPECIAL_OFFER_TYPE = [
    {
        "id": "main_offer",
        "name": "Main Offer"
    },
    {
        "id": "offer_2",
        "name": "Offer 2"
    },
    {
        "id": "offer_3",
        "name": "Offer 3"
    }
];

export const DEAL_TYPE = [
    {
        "id": "daily_reward",
        "name": "Daily Reward"
    },
    {
        "id": "refresh_exchange",
        "name": "Refresh Exchange"
    },
    {
        "id": "sigma_exchange",
        "name": "Sigma Exchange"
    },
    {
        "id": "exchange",
        "name": "Exchange"
    }
];
